import { LS_SESSION_EXPIRED, LS_LAST_PAGE, LS_LAST_SERVICE } from "const/localStorageKeys";

(function () {
    try {
        const url = new URL(window.location.href);
        const isLogin = url.pathname === "/login";
        const sessionKey = url.searchParams.get("session-key");

        if (isLogin && sessionKey) {
            localStorage.removeItem(LS_SESSION_EXPIRED);
            localStorage.removeItem(LS_LAST_PAGE);
            localStorage.removeItem(LS_LAST_SERVICE);
            localStorage.removeItem("userInfo");
            localStorage.removeItem("HAS_BOTH_SERVICE_VALUE");
            localStorage.removeItem("lang");

            sessionStorage.removeItem("login_recently");

            localStorage.setItem("api_key", sessionKey);
        }
    } catch (e) { }
})();